export const GET_BAISHUN_GAMES = "GET_BAISHUN_GAMES";
export const GET_BAISHUN_HISTORY = "GET_BAISHUN_HISTORY";
export const UPDATE_BAISHUN_GAME_STATUS = "UPDATE_BAISHUN_GAME_STATUS";
